module.exports = __webpack_public_path__ + "static/media/meat-and-fruit.6d99d692.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2020-06-06/meat-and-fruit.jpg
// module id = 830
// module chunks = 0